import React from 'react';

import { formatDate } from '../helpers/returns';

const ReturnStatusIndicator = (props) => {
  const statusText = (status) => {
    if (status === 'In-Progress') {
      return 'In Progress';
    }

    return status;
  };

  const statusClass = (status) => {
    if (status === 'Completed') {
      return 'status--success';
    }

    if (status === 'Canceled' || status === 'Deferred') {
      return 'status--default';
    }

    return 'status--warning';
  };

  const { status, useDate, date } = props;

  if (useDate) {
    return (
      <span>
        {`Return Initiated on ${formatDate(new Date(date))}`}
      </span>
    );
  }

  return (
    <span className={`status ${statusClass(status)}`}>
      {`Return ${statusText(status)}`}
    </span>
  );
};

export default ReturnStatusIndicator;
